import React, { useEffect, useState } from 'react';
import {
    Alert,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    TextField,
    Typography,
} from '@mui/material';
import { doSwaggerCall } from '../../../hooks/useApi';
import useNotify from '../../../hooks/useNotify';
import { useAuth } from '../../../hooks/useAuth';

const MIN_COMMENT = 5;

export default function CloseParkingDialog({ ticketId, open, onClose, onClosed }) {
    const { notifyError, notifySuccess } = useNotify();
    const { user } = useAuth();
    const [comment, setComment] = useState('');
    const [pay, setPay] = useState(true);
    const [saving, setSaving] = useState(false);
    const valid = comment.trim().length >= MIN_COMMENT;

    useEffect(() => {
        if (open) {
            setComment('');
            setPay(true);
        }
    }, [open]);

    const submit = () => {
        if (!valid || saving) return;
        setSaving(true);
        doSwaggerCall(
            'ParkingTickets',
            'closeParkingTicket',
            { id: ticketId },
            { comment: comment.trim(), pay }
        )
            .then((res) => {
                notifySuccess(pay ? 'Parkolás kifizetve és lezárva' : 'Parkolás lezárva');
                onClosed(res);
            })
            .catch(notifyError)
            .finally(() => setSaving(false));
    };

    return (
        <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="sm">
            <DialogTitle>Kiengedés és lezárás – {ticketId}</DialogTitle>
            <DialogContent>
                <FormControlLabel
                    sx={{ mb: 1 }}
                    control={<Checkbox checked={pay} onChange={(e) => setPay(e.target.checked)} />}
                    label="Ingyenes kifizetés a parkoló rendszerben (az autó kihajthat)"
                />
                <Alert severity={pay ? 'info' : 'warning'} sx={{ mb: 2 }}>
                    {pay
                        ? 'A jegyet a parkoló rendszerben fizetettnek jelöljük (a vendégnek nem kell fizetnie, a sorompó kiengedi), majd a parkolást az appban is lezárjuk. Ha a parkoló rendszer nem fogadja el, a parkolás nyitva marad.'
                        : 'A lezárás csak a Lurdy rendszerben történik: a felhasználó appjában ez a parkolás többé nem lesz aktív, és nem lehet rá fizetni. A parkoló rendszerben nem változik semmi, az autót a sorompó nem engedi ki.'}{' '}
                    A lezárás nem vonható vissza.
                </Alert>
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={3}
                    required
                    label="Lezárás oka"
                    placeholder="Pl. a jegy a parkolóban beragadt, a vendég kihajtott, ügyfélszolgálati jegy száma…"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    error={comment.length > 0 && !valid}
                    helperText={
                        valid
                            ? ' '
                            : `Kötelező, legalább ${MIN_COMMENT} karakter (${
                                  comment.trim().length
                              }/${MIN_COMMENT})`
                    }
                />
                <Typography variant="caption" color="text.secondary">
                    A lezárást a te nevedben ({user?.email || 'bejelentkezett admin'}) mentjük,
                    időponttal együtt.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={saving}>
                    Mégse
                </Button>
                <Button
                    variant="contained"
                    color="warning"
                    onClick={submit}
                    disabled={!valid || saving}
                    startIcon={saving ? <CircularProgress size={16} /> : null}
                >
                    {pay ? 'Kiengedés és lezárás' : 'Lezárás'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
